











import Vue from 'vue';
import {
  Component, Watch, Prop, Inject,
} from 'vue-property-decorator';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { AnswerMap } from '@/api/AnswerMap';
import { Macro, MacroResource } from '@/api/macro';
import { DocumentResource } from '@/api/document';


@Component
export default class MacroPreview extends Vue {
    @Prop({ default: () => null })
    macro!: Macro | null;

    @Prop({ default: () => null })
    answers!: AnswerMap | null;

    @Prop({ default: '' })
    fiId!: string | null;

    debug: boolean = false;

    previewHtml: string | null = null;

    macroRegex:RegExp = /\[\[BEGIN !*[a-zA-Z0-9_-]*\]|\[END !*[a-zA-Z0-9_-]*\]\]/g;

    nameRegex:RegExp = /\s!*[a-zA-Z0-9_-]*\]/;

    @Inject('MacroResource')
    macroResource!: MacroResource;

    @Inject('DocumentResource')
    documentResource!: DocumentResource;

    mounted() {
      this.refreshPreview();
    }

    @Watch('answers')
    @Watch('fiId')
    @Watch('debug')
    @Watch('macro', { deep: true })
    refreshPreview() {
      this.previewHtml = null;

      if (this.answers && Object.keys(this.answers).length > 0 && this.fiId) {
        let previewPromise: Promise<string> | null = null;
        if (this.macro) {
          previewPromise = this.macroResource.getPreview(this.macro, this.fiId, this.answers, this.debug);
        } else {
          previewPromise = this.documentResource.getPreview(this.fiId, this.answers, this.debug);
        }

        previewPromise!.then((html:string) => {
          this.previewHtml = html;
          if (this.previewHtml === null) {
            this.previewHtml = '';
          } else if (this.debug) {
            this.previewHtml = this.processDebugLinks(this.previewHtml);
          }
          this.$emit('newPreview', this.previewHtml, this.debug);
        }).catch((error:any) => {
          this.showErrorMessage(error);
        });
      }
    }

    processDebugLinks(html:string) : string {
      let newHtml = html;

      let match = this.macroRegex.exec(html);
      while (match !== null) {
        newHtml = newHtml.replace(match[0], this.getDebugLinkReplacement(match[0]));
        match = this.macroRegex.exec(newHtml);
      }
      return newHtml;
    }

    getDebugLinkReplacement(toReplace:string) : string {
      const match = this.nameRegex.exec(toReplace);
      let replacement = toReplace;
      if (match) {
        const macroName = match[0].substring(1, match[0].length - 1);
        let macroLink = macroName;
        if (macroLink.startsWith('!')) {
          macroLink = macroLink.substr(1);
        }
        replacement = replacement.replace(match[0], ` <a href="/macro/${macroLink}" target="_blank">${macroName}</a>]`);
      }
      return replacement;
    }

    showErrorMessage(error: any) {
      console.error(error);
      const al = new Alert(error, NoticeClass.ERROR);
      al.setTimeout(5000);
      this.$store.dispatch('notices/add', al);
    }
}
